import router from "./router";
import store from "./store";
import { getStorage, setStorage } from "@/utils/auth"; // getStorage from Storage
import nprogress from "nprogress";
import "nprogress/nprogress.css";

const whiteList = [
  "/auth/login",
  "/auth/register",
  "/auth/forget",
  "/page/index",
]; // 路由白名单
router.beforeEach((to, from, next) => {
  nprogress.start();
  store.dispatch("setPath", to.path);
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  const token = getStorage("token");
  if (token) {
    // 判断是否有token
    // 如果有token
    if (to.path === "/auth/login") {
      // 从登录路由跳转到首页路由
      // next({
      //   path: "/",
      // });
      // 否则全部重定向到登录页
      store.dispatch("Logout").then(() => {
        // 跳转到登录页
        next({
          path: "/auth/login",
        });
      });
    } else {
      next();
    }
    nprogress.done();
  } else {
    console.log(to);
    // 没有token
    if (whiteList.includes(to.path)) {
      // 在免登录白名单，直接进入
      next();
    } else {
      setStorage("back_url", to.fullPath || "/");
      // 否则全部重定向到登录页
      store.dispatch("Logout").then(() => {
        // 跳转到登录页
        next({
          path: "/auth/login",
        });
      });
    }
    nprogress.done();
  }
});

router.afterEach(() => {});
